import type { QuestionModule } from "../contracts";
import {
  textCore,
  type TextDefinition,
  type TextDraft,
  type TextEvent,
  type TextRaw,
  type TextResponse,
} from "./core";
import { TextView } from "./views";

export const textModule: QuestionModule<
  TextRaw,
  TextDefinition,
  TextDraft,
  TextEvent,
  TextResponse
> = {
  type: "text",
  galleryFeatures: ["baseline", "restored", "empty", "multiline"],
  core: textCore,
  prompt: (definition) => ({
    content: definition.prompt,
    image: definition.image,
    altText: definition.altText,
    error: definition.error,
  }),
  views: {
    default: {
      id: "default",
      label: "Default",
      component: TextView,
      arrangements: ["compact", "wide"],
      requiredControls: ["primary-action", "text-input"],
      input: "host-text",
    },
  },
  defaultDisplay: { view: "default" },
  controls: (definition, draft, _display, copy) => ({
    inputHint: "multitext",
    primaryAction: {
      purpose: "submit",
      label: copy.actions.send,
      action: { type: "submit" },
    },
    ...(definition.dontKnow
      ? {
          secondaryAction: {
            label: definition.dontKnow.label,
            selected: draft.dontKnowSelected,
            action: {
              type: "submit" as const,
              event: { type: "toggle-dont-know" as const },
            },
          },
        }
      : {}),
    textInput: {
      fieldId: "text-answer",
      label: copy.labels.yourAnswer,
      value: draft.value,
      multiline: true,
      event: (value): TextEvent => ({ type: "set-value", value }),
    },
  }),
};
